<div class="w-100-p border border-gray-300" *ngIf="dataSource">
    <mat-table #table [dataSource]="dataSource" matSort>
        <!-- Avatar Column -->
        <ng-container matColumnDef="avatar">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let posting" class="avatar-cell cell-30 pl-20">
                <div #avatarCell>
                    <img class="avatar pointer" [src]="posting.image.url" />
                </div>
            </mat-cell>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'GENERAL.PROPERTY.NAME' | translate }}</mat-header-cell>
            <mat-cell *matCellDef="let posting" fxLayout="column" fxLayoutAlign="center start">
                <span>{{ posting.translations[0].title }}</span>
            </mat-cell>
        </ng-container>

        <!-- Type Column -->
        <ng-container matColumnDef="type">
            <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'GENERAL.PROPERTY.TYPE' | translate }}</mat-header-cell>
            <mat-cell *matCellDef="let posting" fxLayout="column" fxLayoutAlign="center start">
                <span>{{ posting.postingType.displayNameKeySingular }}</span>
            </mat-cell>
        </ng-container>

        <!-- Valid From Column -->
        <ng-container matColumnDef="validFrom">
            <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'GENERAL.PROPERTY.VALID_FROM' | translate }}</mat-header-cell>
            <mat-cell *matCellDef="let posting" fxLayout="column" fxLayoutAlign="center start">
                <span>{{ posting.validFrom | date: 'shortDate' }}</span>
            </mat-cell>
        </ng-container>

        <!-- Valid To Column -->
        <ng-container matColumnDef="validTo">
            <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'GENERAL.PROPERTY.VALID_TO' | translate }}</mat-header-cell>
            <mat-cell *matCellDef="let posting" fxLayout="column" fxLayoutAlign="center start">
                <span>{{ posting.validTo | date: 'shortDate' }}</span>
            </mat-cell>
        </ng-container>

        <!-- Buttons Column -->
        <ng-container matColumnDef="buttons">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let node">
                <div fxFlex="row" fxLayoutAlign="end center">
                    <app-flat-button
                        [label]="'GENERAL.BUTTON.SELECT'"
                        [disabled]="singleSelect && selectedPostingsList?.length > 0"
                        (onClick)="addToList(node)"
                        *ngIf="!node.selected; else selected"
                    ></app-flat-button>
                    <ng-template #selected>
                        <app-white-button [label]="'GENERAL.BUTTON.UNSELECT'" (onClick)="removeFromList(node)"></app-white-button>
                    </ng-template>
                </div>
            </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let user; columns: displayedColumns" class="user" matRipple> </mat-row>
    </mat-table>
    <mat-paginator persistPageSize="posting.select-posting-list" [length]="postingsStateTotalCount$ | async" [pageSize]="5" [pageSizeOptions]="[5, 10, 25]"></mat-paginator>
</div>
